import React from 'react';

export default function XIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L11 11M11 1L1 11" stroke="#4B5563" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}
